const STUDENTLIST = "STUDENTLIST";
const VIDEOPIECE="VIDEOPIECE"
const  CLASSROOMS="CLASSROOMS"
const  USERDATAFORGOT="USERDATAFORGOT"
export { STUDENTLIST,VIDEOPIECE ,CLASSROOMS,USERDATAFORGOT};